module.exports = __webpack_public_path__ + "static/media/luminatouch-5.bf2bf462.jpg";